import { ECLEAR_OPTION_CATEGORY } from '@enechain/eposition-ui/src/models/eclearOption'

import { Maybe } from '~/types/AdvancedTypes'

import { MarginSimulationResultForOption1Models } from './MarginSimulationResultForOption1Models'
import { MarginSimulationResultForOption2Models } from './MarginSimulationResultForOption2Models'

export type MarginSimulationResultModel = Maybe<
  | MarginSimulationResultForOption1Models
  | MarginSimulationResultForOption2Models
>

export function isOption1MarginResult(
  result: MarginSimulationResultModel,
): result is MarginSimulationResultForOption1Models {
  return result?.type === ECLEAR_OPTION_CATEGORY.OPTION_1
}

export function isOption2MarginResult(
  result: MarginSimulationResultModel,
): result is MarginSimulationResultForOption2Models {
  return result?.type === ECLEAR_OPTION_CATEGORY.OPTION_2
}
